"use client";
import React from "react";
import { Tabs as AntdTabs, TabsProps } from "antd";
const TabPane = AntdTabs.TabPane;
const Tabs = ({ items, onChange, ...props }: TabsProps) => {
  return (
    <AntdTabs
      items={items}
      // defaultActiveKey={defaultActiveKey}
      onChange={onChange}
      {...props}
    />
  );
};
export { TabPane };
export default Tabs;
